import React, { Component } from "react";
import { bool, number, string } from "prop-types";
import Logo from "pages/login/_components/Logo";
import { selectors as communicationsSelectors } from "reducers/communications";
import { Link } from "react-router-dom";
import I18n from "pages/_components/I18n";
import Badge from "pages/_components/Badge";
import Image from "pages/_components/Image";
import { connect } from "react-redux";

class HeaderSimple extends Component {
    static propTypes = {
        className: string,
        inverse: bool.isRequired,
        showNotifications: bool,
        unreadCommunications: number,
    };

    static defaultProps = {
        className: "",
        showNotifications: false,
        unreadCommunications: 0,
    };

    render() {
        const { className, inverse, showNotifications, unreadCommunications } = this.props;
        return (
            <header className={`view-header header-simple ${className}`}>
                <Logo inverse={inverse} />
                {showNotifications && (
                    <ul className="nav navbar-nav navbar-right header-command-pallette">
                        <li>
                            <Link to="/environment/communications" className="message">
                                {unreadCommunications > 0 && (
                                    <>
                                        <Badge count={unreadCommunications} />
                                        <I18n id="menu.chat.badge" componentProps={{ className: "visually-hidden" }} />
                                    </>
                                )}
                                <Image className="svg-icon" src="images/figma/icon/bell.svg" />
                            </Link>
                        </li>
                    </ul>
                )}
            </header>
        );
    }
}

const mapStateToProps = (state) => ({
    unreadCommunications: communicationsSelectors.getUnreadCommunications(state),
});

export default connect(mapStateToProps)(HeaderSimple);
